import { UserCheck } from 'lucide-react';
import { UserIdentifiedEvent as UserIdentifiedEventType } from '../types';
import EventShell from './EventShell';

interface Props {
  event: UserIdentifiedEventType;
}

export default function UserIdentifiedEvent({ event }: Props) {
  return (
    <EventShell
      color="blue"
      icon={<UserCheck className="w-3.5 h-3.5" />}
      title="User Identified"
      timestamp={event.created_at}
    >
      {event.payload.user_email && <p className="font-medium text-foreground">{event.payload.user_email}</p>}
      {event.payload.external_id && <p>External ID: {event.payload.external_id}</p>}
      {event.payload.source && <p>Source: {event.payload.source}</p>}
    </EventShell>
  );
}
